export const trackingConstants = {
    TRACK_CONNECTION: 'TRACK_CONNECTION'
  , TRACK_LOGON: 'TRACK_LOGON'
};
